module.exports = __webpack_public_path__ + "static/img/prezzta.8741630e.svg";